import cc from "classcat";
import H5 from "components/atoms/H5"

const VideoWithTitle = ({ link, title = "", verticalMobile = false }) => {
  return (
    <div className="relative flex grow flex-col justify-start rounded-lg">
      {title ? (
        <H5 className="mb-4 grow md:whitespace-pre-line">{title}</H5>
      ) : null}
      <div className={cc([verticalMobile ? "aspect-video-vertical sm:aspect-video" : "aspect-video"])}>
        <iframe
          className="absolute top-0 left-0 h-full w-full rounded-lg"
          src={link}
          title={title}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          allowFullScreen
        />
      </div>
    </div>
  )
}

export default VideoWithTitle
